<template>
<div class="admin-dashboard">
    <nav v-if="currentUser.isAdmin" class="admin-nav">
      <div class="pnav">
        <div
          v-for="group in navGroups"
          :key="group.key"
          class="grp"
          :class="{ current: activeGroup === group.key }">
          <button type="button" @click="showTab(group.tabs[0].key)">
            {{ group.label }} <span class="car">▼</span>
          </button>
          <div class="menu">
            <span
              v-for="tab in group.tabs"
              :key="tab.key"
              class="mi"
              :class="{ on: activeTab === tab.key }"
              @click="showTab(tab.key)">{{ tab.label }}</span>
          </div>
        </div>
      </div>
      <div class="subnav">
        <div
          v-for="tab in activeGroupTabs"
          :key="tab.key"
          class="tab"
          :class="{ active: activeTab === tab.key }"
          @click="showTab(tab.key)">{{ tab.label }}</div>
      </div>
    </nav>
    <div>
      <section v-if="activeTab === 'userAccounts'" class="section pt15">
        <user-accounts/>
      </section>
      <section v-if="activeTab === 'backlinksSurvey'" class="section pt15">
        <backlinks-survey/>
      </section>
      <section v-if="activeTab === 'history'" class="section pt15">
        <history/>
      </section>
      <section v-if="activeTab === 'keywordResearch'" class="section pt15">
        <keyword-research/>
      </section>
      <section v-if="activeTab === 'coupons' && currentUser.isAdmin" class="section pt15">
        <coupons/>
      </section>
      <section v-if="activeTab === 'creditRefillPlans' && currentUser.isAdmin" class="section pt15">
        <admin-credit-refill-plans/>
      </section>
      <section v-if="activeTab == 'watchdogHistory'" class="section pt15">
        <watchdog-history/>
      </section>
      <section v-if="activeTab == 'aiVisibilityTrackers'" class="section pt15">
        <admin-ai-visibility-trackers/>
      </section>
      <section v-if="activeTab == 'watchdogTrack'" class="section pt15">
        <watchdog-track/>
      </section>
      <section v-if="activeTab == 'whiteGlove'" class="section pt15">
        <white-glove/>
      </section>
      <!-- no Bulma section padding: the section's own tab bar spans the page, as in the design -->
      <section v-if="activeTab === 'popAuthority' && currentUser.isAdmin">
        <pop-authority/>
      </section>
      <section v-if="activeTab === 'serpValidation' && currentUser.isAdmin">
        <serp-validation/>
      </section>
      <section v-if="activeTab === 'rateLimits' && currentUser.isAdmin">
        <admin-rate-limits/>
      </section>
      <section v-if="activeTab == 'reviewOptimizations'" class="section pt15">
        <review-optimizations/>
      </section>
      <section v-if="activeTab == 'aiRuns'" class="section pt15">
        <a-i-writer-log-dashboard-for-admin />
      </section>
      <!-- Metrics (design "POP Admin - Usage Metrics.html"): Overview / Usage / Users / Revenue are one page -->
      <section v-if="metricsSection !== null">
        <admin-metrics :section="metricsSection"/>
      </section>
      <section v-if="activeTab === 'metricsAllUsers'">
        <admin-metrics-all-users/>
      </section>
      <section v-if="activeTab === 'notifications'" class="section pt15">
        <admin-notifications/>
      </section>
      <section v-if="activeTab === 'affiliateSales'" class="section pt15">
        <affiliate-sales/>
        <!-- <template v-if="currentUser.isAdmin">
          <affiliate-sales/>
        </template>
        <template v-else>
          <affiliate-sales-for-user />
        </template> -->
      </section>
      <section v-if="activeTab === 'affiliatePayouts'" class="section pt15">
        <affiliate-payouts/>
      </section>
      <section v-if="activeTab === 'paypalRefunds'" class="section pt15">
        <paypal-refunds/>
      </section>
      <section v-if="activeTab === 'apiUsage'" class="section pt15">
        <api-usage-dashboard
          :forAdmin="true"
        ></api-usage-dashboard>
      </section>
    </div>

</div>
</template>

<script>
import UserAccounts from '@/components/Admin/UserAccounts/Index.vue'
import Coupons from '@/components/Admin/Coupons.vue'
import History from '@/components/Admin/History.vue'
import KeywordResearch from '@/components/Admin/KeywordResearch/Index.vue'
import WatchdogHistory from '@/components/Admin/WatchdogHistory.vue'
import WatchdogTrack from '@/components/Admin/WatchdogTrack.vue'
import WhiteGlove from '@/components/Admin/WhiteGlove/Index.vue'
import PopAuthority from '@/components/Admin/PopAuthority/Index.vue'
import SerpValidation from '@/components/Admin/SerpValidation/Index.vue'
import AdminRateLimits from '@/components/Admin/RateLimits/Index.vue'
import AdminMetrics from '@/components/Admin/Metrics/Index.vue'
import AdminMetricsAllUsers from '@/components/Admin/Metrics/AllUsers.vue'
import Notifications from '@/components/Admin/Notifications.vue'
import AffiliateSales from '@/components/Admin/AffiliateSales.vue'
import AffiliatePayouts from '@/components/Admin/AffiliatePayouts.vue'
import PaypalRefunds from '@/components/Admin/PaypalRefunds.vue'
import ApiUsageDashboard from '@/components/ApiUsageDashboard.vue'
import AIWriterLogDashboardForAdmin from '@/components/Admin/AIWriterLogDashboardForAdmin.vue'
import BacklinksSurvey from '@/components/Admin/BackLinkSurvey.vue'
import ReviewOptimizations from '@/components/Admin/ReviewOptimizations.vue'
import AdminAiVisibilityTrackers from '@/components/Admin/AiVisibilityTrackers.vue'
import AdminCreditRefillPlans from '@/components/Admin/CreditRefillPlans.vue'

export default {
  name: 'AdminIndex',
  components: {
    UserAccounts,
    Coupons,
    History,
    KeywordResearch,
    WatchdogHistory,
    WatchdogTrack,
    WhiteGlove,
    PopAuthority,
    SerpValidation,
    AdminRateLimits,
    AdminMetrics,
    AdminMetricsAllUsers,
    AffiliateSales,
    AffiliatePayouts,
    PaypalRefunds,
    AdminNotifications: Notifications,
    ApiUsageDashboard,
    AIWriterLogDashboardForAdmin,
    BacklinksSurvey,
    ReviewOptimizations,
    AdminAiVisibilityTrackers,
    AdminCreditRefillPlans
  },
  data () {
    return {
      activeTab: 'history',
      ready: false,
      navGroups: [
        {
          key: 'manage',
          label: 'Manage',
          tabs: [
            { key: 'userAccounts', label: 'User Accounts' },
            { key: 'coupons', label: 'Coupons' },
            { key: 'creditRefillPlans', label: 'Credit Auto-refills' },
            { key: 'notifications', label: 'Notifications' },
            { key: 'rateLimits', label: 'Rate Limits' }
          ]
        },
        {
          key: 'products',
          label: 'Products',
          tabs: [
            { key: 'history', label: 'POP Runs' },
            { key: 'keywordResearch', label: 'Keyword Research' },
            { key: 'watchdogHistory', label: 'Watchdog History' },
            { key: 'watchdogTrack', label: 'Watchdog Track' },
            { key: 'aiVisibilityTrackers', label: 'AI Visibility' },
            { key: 'aiRuns', label: 'AI Writer' },
            { key: 'reviewOptimizations', label: 'Review Optimizations' },
            { key: 'whiteGlove', label: 'White Glove' },
            { key: 'popAuthority', label: 'POP Authority' },
            { key: 'serpValidation', label: 'SERP Validation' },
            { key: 'apiUsage', label: 'API Usage' },
            { key: 'backlinksSurvey', label: 'Backlinks Survey' }
          ]
        },
        {
          key: 'partners',
          label: 'Partners',
          tabs: [
            { key: 'affiliateSales', label: 'Affiliate Sales' },
            { key: 'affiliatePayouts', label: 'Affiliate Payouts' },
            { key: 'paypalRefunds', label: 'PayPal Refunds' }
          ]
        },
        {
          key: 'metrics',
          label: 'Metrics',
          tabs: [
            { key: 'metricsOverview', label: 'Overview' },
            { key: 'metricsUsage', label: 'Usage' },
            { key: 'metricsUsers', label: 'Users' },
            { key: 'metricsRevenue', label: 'Revenue & credits' },
            { key: 'metricsAllUsers', label: 'All users' }
          ]
        }
      ]
    }
  },
  methods: {
    showTab (tab) {
      this.activeTab = tab
    }
  },
  computed: {
    /** The Metrics page section of the active tab (null when another tab is active). */
    metricsSection () {
      const sections = { metricsOverview: '', metricsUsage: 'usage', metricsUsers: 'users', metricsRevenue: 'money' }
      return Object.prototype.hasOwnProperty.call(sections, this.activeTab) ? sections[this.activeTab] : null
    },
    activeGroup () {
      const group = this.navGroups.find(g => g.tabs.some(t => t.key === this.activeTab))
      return group ? group.key : 'products'
    },
    activeGroupTabs () {
      const group = this.navGroups.find(g => g.key === this.activeGroup)
      return group ? group.tabs : []
    },
    isLoading () {
      return this.$store.state.isLoading
    },
    currentUser() {
      if (this.$store.state.user) {
        return this.$store.state.user
      }
      return {}
    }
  },
  beforeMount() {
    if (this.currentUser.isAffiliate && !this.currentUser.isAdmin) {
      this.activeTab = 'affiliateSales'
    }
  },
  mounted () {
    if (this.$route.query.activeTab) {
      this.activeTab = this.$route.query.activeTab;
    }
    this.$store.commit('setHideSideBar', true)
  }
}
</script>

<style lang="scss" scoped>
.admin-dashboard {
  background: var(--v-mainBgColor-base);
  min-height: 100%;
}
.pnav {
  display: flex;
  align-items: stretch;
  gap: 4px;
  padding: 0 14px;
  background: #fff;
  border-bottom: 1px solid #E4E4E4;
  position: relative;
  z-index: 20;
  .grp {
    position: relative;
    > button {
      font-size: 13px;
      font-weight: 700;
      color: #6B7B7E;
      background: none;
      border: none;
      border-bottom: 2px solid transparent;
      padding: 13px 14px 11px;
      cursor: pointer;
      display: flex;
      align-items: center;
      gap: 6px;
      .car {
        font-size: 9px;
        opacity: .6;
      }
    }
    &:hover > button {
      color: var(--v-mainColor-base);
      background: #f7f8f8;
    }
    &.current > button {
      color: var(--v-profileAnchorColor-base);
      border-bottom-color: var(--v-profileAnchorColor-base);
    }
    .menu {
      position: absolute;
      top: 100%;
      left: 0;
      min-width: 210px;
      background: #fff;
      border: 1px solid #E4E4E4;
      border-radius: 6px;
      box-shadow: 0 4px 18px rgba(1, 71, 81, .14);
      padding: 6px;
      display: none;
      .mi {
        display: block;
        padding: 8px 12px;
        border-radius: 4px;
        font-size: 13px;
        font-weight: 600;
        color: #6B7B7E;
        cursor: pointer;
        white-space: nowrap;
        &:hover {
          background: #f5f6f6;
          color: var(--v-mainColor-base);
        }
        &.on {
          background: var(--v-lightYellowColor-base);
          color: var(--v-profileAnchorColor-base);
        }
      }
    }
    &:hover .menu {
      display: block;
    }
  }
}
.subnav {
  display: flex;
  gap: 26px;
  padding: 0 30px;
  background: #fff;
  border-bottom: 1px solid #E4E4E4;
  .tab {
    font-size: 13px;
    font-weight: 600;
    padding: 11px 0;
    color: #6B7B7E;
    border-bottom: 2px solid transparent;
    margin-bottom: -1px;
    cursor: pointer;
    &.active {
      color: var(--v-profileAnchorColor-base);
      border-bottom-color: var(--v-profileAnchorColor-base);
    }
  }
}
</style>
